import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import clsx from 'clsx'
import Container from '@material-ui/core/Container'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import FormControl from '@material-ui/core/FormControl'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormLabel from '@material-ui/core/FormLabel'
import Popover from '@material-ui/core/Popover'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import ArrowDropDownIcon from 'components/material-symbol/icons/ArrowDropDown'
import useStyles from './styles'
import { InstantSearch, Configure, connectMenu } from 'react-instantsearch-dom'
import algoliasearch from 'algoliasearch/lite'
import {
  ALGOLIA_APP_ID,
  ALGOLIA_API_KEY,
  COACH_ACTIVITIES_INDEX_NAME,
} from 'env'
import ActivityCards from './activity-cards'
import 'instantsearch.css/themes/satellite.css'
import { urlToTitle } from '../../lib/transformStage'
import { AlgoliaPagination } from 'components/search'

const searchClient = algoliasearch(ALGOLIA_APP_ID, ALGOLIA_API_KEY)

const ALL_CATEGORIES_VALUE = 'all'

const CategoryFilter = ({ items, currentRefinement, refine }) => {
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = useState(null)
  const filterMenuOpen = Boolean(anchorEl)
  const hasActiveFilter = Boolean(currentRefinement)
  const activeLabel =
    items.find(item => item.value === currentRefinement)?.label ||
    currentRefinement

  const handleFilterChange = value => {
    refine(value === ALL_CATEGORIES_VALUE ? '' : value)
    setAnchorEl(null)
  }

  return (
    <Box className={classes.filterRow}>
      <Button
        variant="outlined"
        color="default"
        className={clsx(
          classes.filterButton,
          hasActiveFilter && classes.filterButtonActive,
        )}
        aria-controls="activity-categories-menu"
        aria-haspopup="true"
        aria-expanded={filterMenuOpen}
        aria-label={
          hasActiveFilter
            ? `Activity category filter: ${activeLabel} selected`
            : 'Activity category filter'
        }
        onClick={event => setAnchorEl(event.currentTarget)}
        endIcon={<ArrowDropDownIcon />}
      >
        {hasActiveFilter ? activeLabel : 'Categories'}
      </Button>
      <Popover
        id="activity-categories-menu"
        open={filterMenuOpen}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        PaperProps={{
          className: classes.filterMenuPaper,
          style: anchorEl ? { minWidth: anchorEl.clientWidth } : undefined,
        }}
      >
        <Box className={classes.filterMenuContent}>
          <FormControl
            component="fieldset"
            fullWidth
            className={classes.filterForm}
          >
            <FormLabel component="legend" className={classes.filterLegend}>
              Categories
            </FormLabel>
            <RadioGroup
              aria-label="Activity category filter"
              name="activity-category-filter"
              className={classes.filterRadioGroup}
              value={currentRefinement || ALL_CATEGORIES_VALUE}
              onChange={event => handleFilterChange(event.target.value)}
            >
              <FormControlLabel
                value={ALL_CATEGORIES_VALUE}
                className={classes.filterRadioLabel}
                control={<Radio color="primary" size="small" />}
                label="All categories"
              />
              {items.map(item => (
                <FormControlLabel
                  key={item.value}
                  value={item.value}
                  className={classes.filterRadioLabel}
                  control={<Radio color="primary" size="small" />}
                  label={item.label}
                />
              ))}
            </RadioGroup>
          </FormControl>
        </Box>
      </Popover>
    </Box>
  )
}

const CustomCategoryFilter = connectMenu(CategoryFilter)

const ActivitiesPage = () => {
  const classes = useStyles()
  const { stage } = useParams()
  const query =
    'stages:"' + urlToTitle(stage).title + '" AND object_type:activity'

  return (
    <Container className={classes.root}>
      <InstantSearch
        indexName={COACH_ACTIVITIES_INDEX_NAME}
        searchClient={searchClient}
      >
        <Configure filters={`${query}`} hitsPerPage={12} />
        <Box className={classes.toolbar}>
          <CustomCategoryFilter attribute="categories" />
          <Box className={classes.toolbarActions}>
            <AlgoliaPagination variant="table" alwaysShowCount />
          </Box>
        </Box>
        <ActivityCards />
      </InstantSearch>
    </Container>
  )
}

export default ActivitiesPage
